import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "message-plugin"
};
var _hoisted_2 = {
  key: 0,
  "class": "message-plugin-tip"
};
import { TUIStore } from "@tencentcloud/chat-uikit-engine";
import TUIChatEngine from "@tencentcloud/chat-uikit-engine";
import { computed } from "../../adapter-vue";
import messageBubble from "../../components/TUIChat/message-list/message-elements/message-bubble.vue";
import MessageCallGroup from "./message-call/message-call-group.vue";
import MessageCallC2C from "./message-call/message-call-c2c.vue";
import TUICustomerServicePlugin from "@tencentcloud/tui-customer-service-plugin/index.vue";
import { isCustomerServicePluginMessage, isMessageInvisible } from "@tencentcloud/tui-customer-service-plugin";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-plugin',
  props: {
    message: {
      "default": function _default() {
        return {};
      }
    },
    blinkMessageIDList: {
      "default": function _default() {
        return [];
      }
    }
  },
  emits: ["resendMessage", "handleToggleMessageItem", "handleH5LongPress"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var messageModel = computed(function () {
      var _props$message;
      return TUIStore.getMessageModel((_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.ID);
    });
    var messageSignalingInfo = computed(function () {
      var _messageModel$value;
      return messageModel === null || messageModel === void 0 || (_messageModel$value = messageModel.value) === null || _messageModel$value === void 0 ? void 0 : _messageModel$value.getSignalingInfo();
    });
    var messageCustomContent = computed(function () {
      var _messageModel$value2;
      return messageModel === null || messageModel === void 0 || (_messageModel$value2 = messageModel.value) === null || _messageModel$value2 === void 0 ? void 0 : _messageModel$value2.getMessageContent();
    });
    // 需要展示ui的判断逻辑
    var showStyle = computed(function () {
      var _messageSignalingInfo;
      if ((messageSignalingInfo === null || messageSignalingInfo === void 0 || (_messageSignalingInfo = messageSignalingInfo.value) === null || _messageSignalingInfo === void 0 ? void 0 : _messageSignalingInfo.businessID) === 1) {
        var _messageModel$value3, _messageModel$value4;
        if (((_messageModel$value3 = messageModel.value) === null || _messageModel$value3 === void 0 ? void 0 : _messageModel$value3.conversationType) === TUIChatEngine.TYPES.CONV_C2C) {
          return "bubble";
        }
        if (((_messageModel$value4 = messageModel.value) === null || _messageModel$value4 === void 0 ? void 0 : _messageModel$value4.conversationType) === TUIChatEngine.TYPES.CONV_GROUP) {
          return "tip";
        }
      }
      return "";
    });
    // 以下为messageTool等外部交互使用，无需特殊处理，勿动
    var resendMessage = function resendMessage(message) {
      emits("resendMessage", message);
    };
    var handleToggleMessageItem = function handleToggleMessageItem(e, message) {
      var isLongpress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      emits("handleToggleMessageItem", e, message, isLongpress);
    };
    var handleH5LongPress = function handleH5LongPress(e, message, type) {
      emits("handleH5LongPress", e, message, type);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isCustomerServicePluginMessage)(_unref(messageModel)) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!_unref(isMessageInvisible)(_unref(messageModel)) ? (_openBlock(), _createBlock(messageBubble, {
        key: 0,
        messageItem: _unref(messageModel),
        blinkMessageIDList: props.blinkMessageIDList,
        onResendMessage: _cache[0] || (_cache[0] = function ($event) {
          return resendMessage(_unref(messageModel));
        })
      }, {
        "default": _withCtx(function () {
          return [_createVNode(TUICustomerServicePlugin, {
            message: _unref(messageModel)
          }, null, 8, ["message"])];
        }),
        _: 1
      }, 8, ["messageItem", "blinkMessageIDList"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(showStyle) === 'tip' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(MessageCallGroup, {
        message: _unref(messageModel),
        signalingInfo: _unref(messageSignalingInfo),
        customContent: _unref(messageCustomContent),
        blinkMessageIDList: props.blinkMessageIDList
      }, null, 8, ["message", "signalingInfo", "customContent", "blinkMessageIDList"])])) : _unref(showStyle) === 'bubble' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": "message-plugin-bubble-content",
        onLongpress: _cache[2] || (_cache[2] = function ($event) {
          return handleToggleMessageItem($event, _unref(messageModel), true);
        }),
        onContextmenu: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
          return handleToggleMessageItem($event, _unref(messageModel));
        }, ["prevent", "right"])),
        onTouchstart: _cache[4] || (_cache[4] = function ($event) {
          return handleH5LongPress($event, _unref(messageModel), 'touchstart');
        }),
        onTouchend: _cache[5] || (_cache[5] = function ($event) {
          return handleH5LongPress($event, _unref(messageModel), 'touchend');
        }),
        onMouseover: _cache[6] || (_cache[6] = function ($event) {
          return handleH5LongPress($event, _unref(messageModel), 'touchend');
        })
      }, [_createVNode(messageBubble, {
        messageItem: _unref(messageModel),
        blinkMessageIDList: props.blinkMessageIDList,
        onResendMessage: _cache[1] || (_cache[1] = function ($event) {
          return resendMessage(_unref(messageModel));
        })
      }, {
        "default": _withCtx(function () {
          return [_createVNode(MessageCallC2C, {
            message: _unref(messageModel),
            signalingInfo: _unref(messageSignalingInfo),
            customContent: _unref(messageCustomContent)
          }, null, 8, ["message", "signalingInfo", "customContent"])];
        }),
        _: 1
      }, 8, ["messageItem", "blinkMessageIDList"])], 32)) : _createCommentVNode("", true)], 64))]);
    };
  }
});